import { type ReactNode } from 'react'
import { Tag } from '@raspberrypifoundation/design-system-react'

import './Tags.scss'

type TagVariant = 'error' | 'default' | 'success' | 'warning' | 'information'

interface TagsProps {
  variant?: TagVariant
  labels: string[]
}

export function Tags({
  variant = 'default',
  labels,
}: TagsProps): ReactNode | null {
  if (labels.length === 0) return null

  return (
    <div className="sc-pr-tags">
      {labels.map((label, index) => (
        <Tag key={`tag-${index}`} text={label} variant={variant} size="small" />
      ))}
    </div>
  )
}

export default Tags
